import * as yup from "yup";
import { LOCALE } from "../../properties/Locale";

export const TemporaryTrafficChangeFormValidator = yup.object().shape({
  applicantName: yup.string().required(LOCALE.firstNameRequired),
  applicantAddress: yup.string().required(LOCALE.headquartersRequired),
  applicantPlace: yup.string().required(LOCALE.cityRequired),
  applicantPhone: yup.string().required(LOCALE.phoneRequired),

  projectTitle: yup.string().required(LOCALE.projectTitleRequired),
  projectBureauName: yup.string().required(LOCALE.projectBureauNameRequired),
  projectTechnicalNumber: yup
    .string()
    .required(LOCALE.projectTechnicalNumberRequired),
  locationDescription: yup
    .string()
    .required(LOCALE.locationDescriptionRequired),

  applicantEmail: yup
    .string()
    .email(LOCALE.invalidEmailFormat)
    .required(LOCALE.emailRequired),

  uploadedFiles: yup.object().shape({
    trafficPlanPdf: yup
      .mixed()
      .required(LOCALE.trafficPlanPdfRequired)
      .test("fileType", LOCALE.onlyPdfFilesAllowed, (file) =>
        file ? file.type === "application/pdf" : false,
      ),
    trafficPlanDwg: yup
      .mixed()
      .required(LOCALE.trafficPlanDwgRequired)
      .test("fileType", LOCALE.onlyDwgFilesAllowed, (file) =>
        file ? file.name.toLowerCase().endsWith(".dwg") : false,
      ),
  }),
});

export const PermanentTrafficChangeFormValidator = yup.object().shape({
  applicantName: yup.string().required(LOCALE.firstNameRequired),
  applicantAddress: yup.string().required(LOCALE.headquartersRequired),
  applicantPlace: yup.string().required(LOCALE.cityRequired),
  applicantPhone: yup.string().required(LOCALE.phoneRequired),

  projectTitle: yup.string().required(LOCALE.projectTitleRequired),
  projectBureauName: yup.string().required(LOCALE.projectBureauNameRequired),
  projectTechnicalNumber: yup
    .string()
    .required(LOCALE.projectTechnicalNumberRequired),
  locationDescription: yup
    .string()
    .required(LOCALE.locationDescriptionRequired),

  applicantEmail: yup
    .string()
    .email(LOCALE.invalidEmailFormat)
    .required(LOCALE.emailRequired),

  uploadedFiles: yup.object().shape({
    trafficPlanPdf: yup
      .mixed()
      .required(LOCALE.trafficPlanPdfRequired)
      .test("fileType", LOCALE.onlyPdfFilesAllowed, (file) =>
        file ? file.type === "application/pdf" : false,
      ),
    trafficPlanDwg: yup
      .mixed()
      .required(LOCALE.trafficPlanDwgRequired)
      .test("fileType", LOCALE.onlyDwgFilesAllowed, (file) =>
        file ? file.name.toLowerCase().endsWith(".dwg") : false,
      ),
    projectRevision: yup
      .mixed()
      .required(LOCALE.projectRevisionRequired)
      .test("fileType", LOCALE.onlyDwgOrPdfFilesAllowed, (file) =>
        file
          ? file.name.toLowerCase().endsWith(".dwg") ||
            file.name.toLowerCase().endsWith(".pdf")
          : false,
      ),

    urbanPlanPdf: yup
      .mixed()
      .required(LOCALE.urbanPlanPdfRequired)
      .test("fileType", LOCALE.onlyPdfFilesAllowed, (file) =>
        file ? file.type === "application/pdf" : false,
      ),
    urbanPlanDwg: yup
      .mixed()
      .required(LOCALE.urbanPlanDwgRequired)
      .test("fileType", LOCALE.onlyDwgFilesAllowed, (file) =>
        file ? file.name.toLowerCase().endsWith(".dwg") : false,
      ),
  }),
});
